import React, { useState } from 'react';
import StarRating from './StarRating';
import apiClient from '../Api/axiosConfig';
import './FeedbackForm.css';

const FeedbackForm = ({ bookId, onSuccess }) => {
  const [rating, setRating] = useState(0);
  const [nickname, setNickname] = useState('');
  const [email, setEmail] = useState('');
  const [text, setText] = useState('');
  const [status, setStatus] = useState({ state: 'idle', message: '' }); // idle, sending, success, error

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (rating === 0 || !nickname || !email || !text) {
      setStatus({ state: 'error', message: 'Kérlek, tölts ki minden mezőt és adj értékelést!' });
      return;
    }
    setStatus({ state: 'sending', message: 'Küldés...' });

    try{
      const response = await apiClient.post('/feedback/submit', {bookId, rating, nickname, email, text});
      setStatus({ state: 'success', message: response.data.message || "Köszünjük a visszajelzésed!"});
      if(onSuccess){ onSuccess(); };
      setRating(0);
      setNickname('');
      setEmail('');
      setText('');
    }catch(error){
      setStatus({ state: 'error', message: `Hiba: ${error.response?.data?.message || error.message || 'Ismeretlen szerverhiba!'}`});
    }
  };

  return (
    <form className="feedback-form" onSubmit={handleSubmit}>
      <h3>Visszajelzés a könyvről</h3>
      <StarRating rating={rating} setRating={setRating} />
      <div className="form-row">
        <input type="text" placeholder="Becenév" value={nickname} onChange={e => setNickname(e.target.value)} />
        <input type="email" placeholder="E-mail cím" value={email} onChange={e => setEmail(e.target.value)} />
      </div>
      <textarea placeholder="Írd le a véleményed..." value={text} onChange={e => setText(e.target.value)} />
      <button type="submit" disabled={status.state === 'sending'}>
        {status.state === 'sending' ? 'Küldés...' : 'Visszajelzés küldése'}
      </button>
      {status.state !== 'idle' && (
        <p className={`status-message ${status.state}`}>{status.message}</p>
      )}
    </form>
  );
};

export default FeedbackForm;